export default "__VITE_ASSET__foC4$u7A__";